import { services } from '../data/services';
import { useScrollReveal } from '../hooks/useScrollReveal';

const ServiceCard = ({ service }) => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <article ref={ref} className={`service-card fade-section ${isVisible ? 'is-visible' : ''}`}>
      <div className="service-card__media">
        <img src={service.image} alt={service.title} loading="lazy" />
      </div>
      <div className="service-card__body">
        <div className="service-card__icon" aria-hidden="true">
          <i className={service.icon} />
        </div>
        <h3>{service.title}</h3>
        <p>{service.description}</p>
      </div>
    </article>
  );
};

export const Services = () => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="services" className="section services-section">
      <div className="container">
        <div ref={ref} className={`section-heading fade-section ${isVisible ? 'is-visible' : ''}`}>
          <span className="section-eyebrow">Our Services</span>
          <h2>Crafted for stress-free celebrations</h2>
          <p>Explore the toolkit powering your digital wedding experience.</p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};
